<template lang="pug">
  .slider(
    v-if="hide === false || baseValue > 0"
    )
    p {{ title }}
    .el-slider--with-input
      formatted-number(
        class="el-slider__input"
        ref="input"
        :value="value"
        :min="min"
        :step="step"
        :max="max"
        size="small"
        @input="$emit('input', $event)"
        :formatter="formatter"
        :parser="parser"
      )
      el-slider(
        color="yellow"
        tooltip-class="tooltip"
        :min="min"
        :step="step"
        :max="max"
        :format-tooltip="formatter"
        :value="value"
        @input="$emit('input', $event)"
      )

</template>

<script>

import FormattedNumber from './FormattedNumber'

export default {
  name: 'Slider',
  components: { FormattedNumber },
  props: {
    title: String,
    min: Number,
    step: Number,
    max: Number,
    customFormatter: Function,
    value: Number,
    baseValue: Number,
    hide: Boolean,
    type: {
      type: String,
      default: 'number'
    },
    precision: Number
  },
  computed: {
    formatter () {
      if (this.type === 'percent') {
        return this.formatPercent
      } else if (this.type === 'number') {
        return this.formatNumber
      } else {
        return value => value
      }
    },
    parser () {
      if (this.type === 'percent') {
        return value => value.replace('%', '') / 100
      } else {
        return value => value
      }
    }
  },
  methods: {
    formatPercent (value) {
      if (value === null) {
        return value
      }
      value = value * 100
      if (this.precision !== undefined) {
        value = value.toFixed(this.precision - 2)
      }
      return `${value}%`
    },
    formatNumber (value) {
      if (value === null) {
        return value
      }
      if (this.precision !== undefined) {
        value = value.toFixed(this.precision)
      }
      return value
    }
  }
}
</script>

<style scoped>
p {
  margin-top: 5px;
  margin-bottom: 0;
}

.el-slider {
  margin-right: 160px;
}
</style>
